import { Typography } from "@mui/material";
import { EXPORT_TYPE } from "modules/DeclareLeave/redux/formFilterHrReport";
import {
  formFilterHrReportSelector,
  numberCanLateHrReportSelector,
  theFirstDataHrReportSelector,
} from "modules/DeclareLeave/redux/selector";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import pxToRem from "theme/base/pxToRem";

const centerHeaderStyle = (cols, isAlignEnd?: boolean) => {
  if (!cols) return [];
  return cols?.map((col) => ({
    ...col,
    headerStyle: {
      ...col?.headerStyle,
      display: "flex",
      justifyContent: "center",
      alignItems: isAlignEnd ? "end" : col?.headerStyle?.alignItems || "center",
    },
    columns: col?.columns ? centerHeaderStyle(col?.columns) : undefined,
    cell: col?.isCenter
      ? (info) => (
          <Typography
            sx={(theme) => ({
              fontSize: pxToRem(12),
              color: theme.palette.text.textPrimary,
              width: "100%",
              textAlign: "center",
            })}
          >
            {info.getValue()}
          </Typography>
        )
      : col.cell || ((info) => info.getValue()), // fallback if no cell defined
  }));
};

const getColumns = (subCols, type) => {
  if (!subCols) return [];
  return subCols?.map((col, idx) => ({
    id: `${col?.label}_${idx}_${type}`,
    accessorKey: col?.code,
    header: <Typography sx={{ textAlign: "center" }}>{col?.label}</Typography>,
    width: 90,
    minSize: 90,
    cell: (info) => (
      <Typography
        sx={(theme) => ({
          fontSize: pxToRem(12),
          color: theme.palette.text.textPrimary,
          width: "100%",
          textAlign: "center",
          textWrap: "wrap",
          whiteSpace: "wrap",
          textOverflow: "hidden",
        })}
      >
        {info?.row?.original?.[type]!?.[idx]?.value}
      </Typography>
    ),
    footer: (props) => props.column.id,
    pinPosition: "left",
    headerStyle: {
      padding: 0,
      display: "flex",
      justifyContent: "center",
    },
    customStyle: {
      justifyContent: "center",
    },
    enableSorting: false,
  }));
};

const useColumns = () => {
  const numberLate = useSelector(numberCanLateHrReportSelector);
  const data = useSelector(theFirstDataHrReportSelector); // phần tử đầu tiên của mảng data
  const { type } = useSelector(formFilterHrReportSelector);

  const defaultColumns = [
    // {
    //   id: "departmentLevel1Name",
    //   accessorKey: "departmentLevel1Name",
    //   header: "Đơn vị cấp 1",
    //   footer: (props) => props.column.id,
    //   minSize: 250,
    //   cell: ({ row, getValue }) => (
    //     <Box
    //       sx={{
    //         display: "flex",
    //         justifyItems: "left",
    //         width: "100%",
    //       }}
    //     >
    //       <Box
    //         sx={{
    //           width: "100%",
    //           display: "flex",
    //           justifyItems: "left",
    //           alignItems: "center",
    //         }}
    //       >
    //         {/* {row.getCanExpand() && (
    //           <IconButton
    //             {...{
    //               style: { cursor: "pointer" },
    //             }}
    //           >
    //             {row.getIsExpanded() && <IconChevronDown />}
    //           </IconButton>
    //         )} */}
    //         <Box
    //           sx={{
    //             width: "100%",
    //             textAlign: row.getCanExpand() ? "left" : "right",
    //             fontWeight: row.getCanExpand() ? "600" : "inherit",
    //           }}
    //         >
    //           {getValue()}
    //         </Box>
    //       </Box>
    //     </Box>
    //   ),
    //   pinPosition: "center",
    //   enableSorting: false,
    // },
    {
      id: "index",
      accessorKey: "index",
      header: "STT",
      width: 50,
      minSize: 50,

      cell: (info) => (
        <Typography
          sx={(theme) => ({
            fontSize: pxToRem(12),
            color: theme.palette.text.textPrimary,
            width: "100%",

            textAlign: "center",
          })}
        >
          {info.row.index + 1 < 10
            ? `0${info.row.index + 1}`
            : info.row.index + 1}
        </Typography>
      ),
      footer: (props) => props.column.id,
      pinPosition: "left",
    },

    {
      id: "workingAreaName",
      accessorKey: "workingAreaName",
      header: "Khu vực",
      footer: (props) => props.column.id,
      minSize: 100,
      width: 100,
      pinPosition: "center",
      enableSorting: false,
    },

    {
      id: "employeeCode",
      accessorKey: "employeeCode",
      header: "Mã NV",
      minSize: 150,
      pinPosition: "left",
      enableSorting: false,
    },
    {
      id: "employeeName",
      accessorKey: "employeeName",
      header: "Tên nhân viên",
      footer: (props) => props.column.id,
      minSize: 150,
      pinPosition: "center",
      enableSorting: false,
    },
    {
      id: "positionName",
      accessorKey: "positionName",
      header: "Chức danh",
      footer: (props) => props.column.id,
      minSize: 150,
      pinPosition: "left",
      enableSorting: false,
    },
    {
      id: "departmentLevel1Name",
      accessorKey: "departmentLevel1Name",
      header: "Đơn vị cấp 1",
      footer: (props) => props.column.id,
      minSize: 150,
      pinPosition: "left",
      enableSorting: false,
    },
    {
      id: "departmentLevel2Name",
      accessorKey: "departmentLevel2Name",
      header: "Đơn vị cấp 2",
      footer: (props) => props.column.id,
      minSize: 150,
      pinPosition: "center",
      enableSorting: false,
    },
  ];

  const listHeaderCheckInOut = useMemo(() => {
    if (!data || type !== EXPORT_TYPE.CHECK_IN_OUT) return [];
    return [
      {
        id: "timekeepingType",
        accessorKey: "timekeepingType",
        header: "Đối tượng chấm công",
        footer: (props) => props.column.id,
        minSize: 100,
        pinPosition: "left",
        enableSorting: false,
        // headerStyle: {
        //   alignItems: "end",
        // },
      },
      {
        id: "regulationWorkDay",
        accessorKey: "regulationWorkDay",
        header: "Tổng ngày công chuẩn",
        footer: (props) => props.column.id,
        minSize: 100,
        pinPosition: "left",
        enableSorting: false,
        // headerStyle: {
        //   alignItems: "end",
        // },
        cell: (info) => (
          <Typography
            sx={(theme) => ({
              fontSize: pxToRem(12),
              color: theme.palette.text.textPrimary,
              width: "100%",
              textAlign: "center",
              textWrap: "wrap",
              whiteSpace: "wrap",
              textOverflow: "hidden",
            })}
          >
            {info?.getValue()}
          </Typography>
        ),
      },
      {
        id: "totalNoSalaryDays",
        accessorKey: "totalNoSalaryDays",
        header: "Tổng số ngày không tính lương",
        footer: (props) => props.column.id,
        minSize: 100,
        pinPosition: "left",
        enableSorting: false,
        // headerStyle: {
        //   alignItems: "end",
        // },
        cell: (info) => (
          <Typography
            sx={(theme) => ({
              fontSize: pxToRem(12),
              color: theme.palette.text.textPrimary,
              width: "100%",
              textAlign: "center",
              textWrap: "wrap",
              whiteSpace: "wrap",
              textOverflow: "hidden",
            })}
          >
            {info?.getValue()}
          </Typography>
        ),
      },
      {
        id: "totalSalaryDays",
        accessorKey: "totalSalaryDays",
        header: "Tổng số ngày tính lương",
        footer: (props) => props.column.id,
        minSize: 100,
        pinPosition: "left",
        enableSorting: false,
        // headerStyle: {
        //   alignItems: "end",
        // },
        cell: (info) => (
          <Typography
            sx={(theme) => ({
              fontSize: pxToRem(12),
              color: theme.palette.text.textPrimary,
              width: "100%",
              textAlign: "center",
              textWrap: "wrap",
              whiteSpace: "wrap",
              textOverflow: "hidden",
            })}
          >
            {info?.getValue()}
          </Typography>
        ),
      },
      {
        id: "totalFullCheckInOut",
        accessorKey: "totalFullCheckInOut",
        header: "Số ngày chấm công đủ",
        footer: (props) => props.column.id,
        minSize: 100,
        pinPosition: "left",
        enableSorting: false,
        // headerStyle: {
        //   alignItems: "end",
        // },
        cell: (info) => (
          <Typography
            sx={(theme) => ({
              fontSize: pxToRem(12),
              color: theme.palette.text.textPrimary,
              width: "100%",
              textAlign: "center",
              textWrap: "wrap",
              whiteSpace: "wrap",
              textOverflow: "hidden",
            })}
          >
            {info?.getValue()}
          </Typography>
        ),
      },
      {
        id: "paidLeaveReasons",
        accessorKey: "paidLeaveReasons",
        header: "Số ngày nghỉ được hưởng nguyên lương",
        footer: (props) => props.column.id,
        minSize: (data?.paidLeaveReasons?.length || 1) * 90,
        pinPosition: "center",
        enableSorting: false,
        isCenter: true,
        columns: getColumns(data?.paidLeaveReasons, "paidLeaveReasons") || [],
      },
      {
        id: "unpaidLeaveReasons",
        accessorKey: "unpaidLeaveReasons",
        header: "Số ngày nghỉ không hưởng lương",
        footer: (props) => props.column.id,
        minSize: (data?.unpaidLeaveReasons?.length || 1) * 90,
        pinPosition: "center",
        enableSorting: false,
        isCenter: true,
        columns:
          getColumns(data?.unpaidLeaveReasons, "unpaidLeaveReasons") || [],
      },
      {
        id: "totalExplainIsApproved",
        accessorKey: "totalExplainIsApproved",
        header:
          // <Typography>
          "Số ngày quên chấm công và giải trình được duyệt",
        // </Typography>
        footer: (props) => props.column.id,
        minSize: 90,
        pinPosition: "center",
        enableSorting: false,
        isCenter: true,
        // customStyle: {
        //   // position: "relative",
        //   // top: "55px",
        //   // zIndex: 1000,
        // },
        // headerStyle: {
        //   // zIndex: 10,
        //   overflow: "unset",
        // },
      },
      {
        id: "autoTransfers",
        accessorKey: "autoTransfers",
        header: "Số ngày quên chấm công vượt quy định",
        footer: (props) => props.column.id,
        minSize: (data?.autoTransfers?.length || 1) * 90,
        pinPosition: "center",
        enableSorting: false,
        isCenter: true,
        columns: getColumns(data?.autoTransfers, "autoTransfers") || [],
      },
    ];
  }, [data, type]);

  // Báo cáo chấm công của CBNV
  const summaryReportCols = useMemo(
    () => [
      ...centerHeaderStyle(defaultColumns),
      ...centerHeaderStyle(listHeaderCheckInOut),
    ],
    [listHeaderCheckInOut]
  );

  // Báo cáo ngày phép
  const leaveDaysCols = [
    ...defaultColumns,
    {
      id: "leaveBalanceCurrentYear",
      accessorKey: "leaveBalanceCurrentYear",
      header: `Số ngày phép trong năm`,
      footer: (props) => props.column.id,
      minSize: 150,
      pinPosition: "center",
      isCenter: true,
      enableSorting: false,
    },
    {
      id: "leaveBalanceLastYear",
      accessorKey: "leaveBalanceLastYear",
      header: `Số ngày phép tồn năm trước`,
      footer: (props) => props.column.id,
      minSize: 150,
      enableSorting: false,
      pinPosition: "left",
      isCenter: true,
    },
    {
      id: "leaveBasedOnSeniority",
      accessorKey: "leaveBasedOnSeniority",
      header: "Phép thâm niên",
      footer: (props) => props.column.id,
      minSize: 150,
      enableSorting: false,
      pinPosition: "left",
      isCenter: true,
    },
    {
      id: "usedLeaveThisYear",
      accessorKey: "usedLeaveThisYear",
      header: "Số ngày phép đã sử dụng trong năm",
      footer: (props) => props.column.id,
      minSize: 150,
      enableSorting: false,
      pinPosition: "left",
      isCenter: true,
    },
    {
      id: "totalLeaveUsed",
      accessorKey: "totalLeaveUsed",
      header: "Tổng số ngày phép còn lại",
      footer: (props) => props.column.id,
      minSize: 150,
      enableSorting: false,
      pinPosition: "left",
      isCenter: true,
    },
  ];

  // Báo cáo nghỉ bù
  const compensatoryLeaveCols = [
    ...defaultColumns,
    // {
    //   id: "residualCompensatory",
    //   accessorKey: "residualCompensatory",
    //   header: "Số ngày nghỉ bù tồn tháng trước",
    //   footer: (props) => props.column.id,
    //   minSize: 150,
    //   enableSorting: false,
    //   pinPosition: "left",
    //   isCenter: true,
    // },
    {
      id: "increaseCompensateInMonth",
      accessorKey: "increaseCompensateInMonth",
      header: "Số ngày nghỉ bù trong tháng",
      footer: (props) => props.column.id,
      minSize: 150,
      enableSorting: false,
      pinPosition: "left",
      isCenter: true,
    },
    // {
    //   id: "totalCompensatoryLeave",
    //   accessorKey: "totalCompensatoryLeave",
    //   header: "Số ngày nghỉ bù đã sử dụng trong tháng",
    //   footer: (props) => props.column.id,
    //   minSize: 150,
    //   enableSorting: false,
    //   pinPosition: "left",
    //   isCenter: true,
    // },
    // {
    //   id: "remainCompensateLastMonth",
    //   accessorKey: "remainCompensateLastMonth",
    //   header: "Tồn nghỉ bù",
    //   footer: (props) => props.column.id,
    //   minSize: 150,
    //   enableSorting: false,
    //   pinPosition: "left",
    //   isCenter: true,
    // },
    // {
    //   id: "availableForNextMonth",
    //   accessorKey: "availableForNextMonth",
    //   header: "Số ngày nghỉ bù chuyển sang tháng sau",
    //   footer: (props) => props.column.id,
    //   minSize: 150,
    //   enableSorting: false,
    //   pinPosition: "left",
    //   isCenter: true,
    // },
  ];

  // Báo cáo đi muộn về sớm
  const lateEarlyCols = useMemo(
    () => [
      ...defaultColumns,
      {
        id: "workdays",
        accessorKey: "workdays",
        header: "Tổng số lượt",
        footer: (props) => props.column.id,
        enableSorting: false,
        minSize: 450,
        columns: [
          {
            accessorFn: (row) => row.totalGoingLateLess,
            id: "totalGoingLateLess",
            header: `Đi muộn <= ${numberLate || 0} phút`,
            minSize: 90,
            enableSorting: false,
            cell: (info) => (
              <Typography
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                  width: "100%",
                  textAlign: "center",
                })}
              >
                {info.getValue()}
              </Typography>
            ),
          },
          {
            accessorFn: (row) => row.totalGoingLateExceed,
            id: "totalGoingLateExceed",
            header: `Đi muộn > ${numberLate || 0} phút`,
            minSize: 90,
            enableSorting: false,
            cell: (info) => (
              <Typography
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                  width: "100%",
                  textAlign: "center",
                })}
              >
                {info.getValue()}
              </Typography>
            ),
          },
          {
            accessorFn: (row) => row.totalGoingEarlyLess,
            id: "totalGoingEarlyLess",
            header: `Về sớm <= ${numberLate || 0} phút`,
            minSize: 90,
            enableSorting: false,
            cell: (info) => (
              <Typography
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                  width: "100%",
                  textAlign: "center",
                })}
              >
                {info.getValue()}
              </Typography>
            ),
          },
          {
            accessorFn: (row) => row.totalGoingEarlyExceed,
            id: "totalGoingEarlyExceed",
            cell: (info) => (
              <Typography
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                  width: "100%",
                  textAlign: "center",
                })}
              >
                {info.getValue()}
              </Typography>
            ),
            enableSorting: false,
            header: `Về sớm > ${numberLate || 0} phút`,
            minSize: 90,
          },
          {
            accessorFn: (row) => row.totalLateAndEarly,
            id: "totalLateAndEarly",
            cell: (info) => (
              <Typography
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                  width: "100%",
                  textAlign: "center",
                })}
              >
                {info.getValue()}
              </Typography>
            ),
            enableSorting: false,
            header: `Tổng cộng đi muộn/về sớm`,
            minSize: 90,
          },
        ],
        pinPosition: "left",
      },
      {
        id: "leaveDays",
        accessorKey: "leaveDays",
        header: "Tổng số thời gian (Số phút)",
        footer: (props) => props.column.id,
        enableSorting: false,
        minSize: 250,
        columns: [
          {
            accessorFn: (row) => row.totalMinuteGoingLate,
            enableSorting: false,
            id: "totalMinuteGoingLate",
            header: "Đi muộn",
            minSize: 125,
            cell: (info) => (
              <Typography
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                  width: "100%",
                  textAlign: "center",
                })}
              >
                {info.getValue()}
              </Typography>
            ),
          },
          {
            accessorFn: (row) => row.totalMinuteLeaveEarly,
            id: "totalMinuteLeaveEarly",
            cell: (info) => (
              <Typography
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                  width: "100%",
                  textAlign: "center",
                })}
              >
                {info.getValue()}
              </Typography>
            ),
            header: "Về sớm",
            enableSorting: false,
            minSize: 125,
          },
        ],
        pinPosition: "left",
      },
      {
        id: "totalWorkDays",
        accessorKey: "totalWorkDays",
        header: "Số lần được phê duyêt/từ chối",
        footer: (props) => props.column.id,
        minSize: 250,
        columns: [
          {
            accessorFn: (row) => row.totalNumberApproved,
            id: "totalNumberApproved",
            header: (
              <Typography
                sx={{
                  fontSize: pxToRem(12),
                }}
              >
                Được phê duyệt{" "}
                <Typography
                  sx={(theme) => ({
                    color: theme.palette.colorsBase.gray_4,
                    fontSize: pxToRem(12),
                  })}
                >
                  (gồm: các TH đi muộn/về sớm &lt;= {numberLate || 0} phút + các
                  TH được phê duyệt trên Iportal)
                </Typography>
              </Typography>
            ),
            minSize: 125,
            cell: (info) => (
              <Typography
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                  width: "100%",
                  textAlign: "center",
                })}
              >
                {info.getValue()}
              </Typography>
            ),
            enableSorting: false,
          },
          {
            accessorFn: (row) => row.totalNumberRefused,
            id: "totalNumberRefused",
            cell: (info) => (
              <Typography
                sx={(theme) => ({
                  fontSize: pxToRem(12),
                  color: theme.palette.text.textPrimary,
                  width: "100%",
                  textAlign: "center",
                })}
              >
                {info.getValue()}
              </Typography>
            ),
            header: (
              <Typography
                sx={{
                  fontSize: pxToRem(12),
                }}
              >
                Bị từ chối
                <Typography
                  sx={(theme) => ({
                    color: theme.palette.colorsBase.gray_4,
                    fontSize: pxToRem(12),
                  })}
                >
                  (gồm: các TH đi muộn/về sớm &gt; {numberLate || 0} phút và bị
                  từ chối trên Iportal)
                </Typography>
              </Typography>
            ),
            minSize: 125,
            enableSorting: false,
          },
        ],
        pinPosition: "center",
        enableSorting: false,
      },
    ],
    [numberLate]
  );

  // Báo cáo chi tiết chấm công
  const timekeepingFormCols = [
    ...defaultColumns,
    {
      id: "dateAttend",
      accessorKey: "dateAttend",
      header: "Ngày",
      footer: (props) => props.column.id,
      minSize: 150,
      pinPosition: "center",
      enableSorting: false,
      isCenter: true,
    },
    {
      id: "dayOfWeek",
      accessorKey: "dayOfWeek",
      header: "Thứ",
      footer: (props) => props.column.id,
      minSize: 150,
      pinPosition: "center",
      enableSorting: false,
      isCenter: true,
    },
    {
      id: "arriveTime",
      accessorKey: "arriveTime",
      header: "Giờ đến",
      footer: (props) => props.column.id,
      minSize: 100,
      pinPosition: "center",
      enableSorting: false,
      isCenter: true,
    },
    {
      id: "leaveTime",
      accessorKey: "leaveTime",
      header: "Giờ về",
      footer: (props) => props.column.id,
      minSize: 100,
      pinPosition: "center",
      enableSorting: false,
      isCenter: true,
    },
    {
      id: "lateTime",
      accessorKey: "lateTime",
      header: "Số phút đi muộn",
      footer: (props) => props.column.id,
      minSize: 180,
      pinPosition: "left",
      enableSorting: false,
      columns: [
        {
          accessorFn: (row) => row.numberMinutesLate,
          id: "numberMinutesLate",
          header: `Theo QĐ`,
          minSize: 90,
          enableSorting: false,
          cell: (info) => (
            <Typography
              sx={(theme) => ({
                fontSize: pxToRem(12),
                color: theme.palette.text.textPrimary,
                width: "100%",
                textAlign: "center",
              })}
            >
              {info.getValue()}
            </Typography>
          ),
        },
        {
          accessorFn: (row) => row.numberMinutesLateFinal,
          id: "numberMinutesLateFinal",
          header: `Sau khi xin đi muộn`,
          minSize: 90,
          enableSorting: false,
          cell: (info) => (
            <Typography
              sx={(theme) => ({
                fontSize: pxToRem(12),
                color: theme.palette.text.textPrimary,
                width: "100%",
                textAlign: "center",
              })}
            >
              {info.getValue()}
            </Typography>
          ),
        },
      ],
    },
    {
      id: "leaveSoonTime",
      accessorKey: "leaveSoonTime",
      header: "Số phút về sớm",
      footer: (props) => props.column.id,
      minSize: 180,
      pinPosition: "left",
      enableSorting: false,
      columns: [
        {
          accessorFn: (row) => row.numberMinutesEarly,
          id: "numberMinutesEarly",
          header: `Theo QĐ`,
          minSize: 90,
          enableSorting: false,
          cell: (info) => (
            <Typography
              sx={(theme) => ({
                fontSize: pxToRem(12),
                color: theme.palette.text.textPrimary,
                width: "100%",
                textAlign: "center",
              })}
            >
              {info.getValue()}
            </Typography>
          ),
        },
        {
          accessorFn: (row) => row.numberMinutesEarlyFinal,
          id: "numberMinutesEarlyFinal",
          header: `Sau khi xin đi muộn`,
          minSize: 90,
          enableSorting: false,
          cell: (info) => (
            <Typography
              sx={(theme) => ({
                fontSize: pxToRem(12),
                color: theme.palette.text.textPrimary,
                width: "100%",
                textAlign: "center",
              })}
            >
              {info.getValue()}
            </Typography>
          ),
        },
      ],
    },
    {
      id: "numberWorkingHours",
      accessorKey: "numberWorkingHours",
      header: "Tổng số thời gian làm việc theo QĐ",
      footer: (props) => props.column.id,
      minSize: 100,
      pinPosition: "left",
      enableSorting: false,
      isCenter: true,
    },
    {
      id: "overtime",
      accessorKey: "overtime",
      header: "Tổng số thời gian làm thêm ngoài giờ",
      footer: (props) => props.column.id,
      minSize: 100,
      pinPosition: "left",
      enableSorting: false,
      isCenter: true,
    },
    {
      id: "workShiftName",
      accessorKey: "workShiftName",
      header: "Ca làm việc",
      footer: (props) => props.column.id,
      minSize: 100,
      pinPosition: "left",
      enableSorting: false,
      isCenter: true,
    },
    // {
    //   id: "totalOffDay",
    //   accessorKey: "totalOffDay",
    //   header: "Số ngày đăng ký nghỉ/Lễ",
    //   footer: (props) => props.column.id,
    //   minSize: 100,
    //   pinPosition: "left",
    //   enableSorting: false,
    //   isCenter: true,
    // },
    // {
    //   id: "totalTransferToLeave",
    //   accessorKey: "totalTransferToLeave",
    //   header: "Số ngày bị tự động chuyển đổi (NB/P)",
    //   footer: (props) => props.column.id,
    //   minSize: 100,
    //   pinPosition: "left",
    //   enableSorting: false,
    //   isCenter: true,
    // },
  ];

  return {
    summaryReportCols: summaryReportCols,
    leaveDaysCols: centerHeaderStyle(leaveDaysCols),
    compensatoryLeaveCols: centerHeaderStyle(compensatoryLeaveCols),
    lateEarlyCols: centerHeaderStyle(lateEarlyCols),
    timekeepingFormCols: centerHeaderStyle(timekeepingFormCols),
  };
};

export default useColumns;
